import PortalRoleAndAssignmentsBoilerplate from "./boilerPlates/roleBoilerplates/PortalRoleAndAssignmentsBoilerplate"
import ratmHash from "./RATMHash"

const cloneRoleAndAssignments = (roleId: number) => {
    const { lookupHashTableItem } = ratmHash
    const bucketItem = lookupHashTableItem(roleId, 0)
    if (bucketItem) {
        const cloned = JSON.parse(JSON.stringify(bucketItem))
        return {
            Role: cloned[1].role,
            Assignments: cloned[2].assignments
        }
    }
    return JSON.parse(JSON.stringify(PortalRoleAndAssignmentsBoilerplate))
}

export default cloneRoleAndAssignments